
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.181 18.88l-4.164-3.77c-1.231-1.114-.647-3.157.988-3.451l6.492-1.168a2 2 0 001.447-1.098l2.255-4.667c.728-1.507 2.874-1.507 3.602 0l2.256 4.667a2 2 0 001.446 1.098l6.492 1.168c1.635.294 2.22 2.336.988 3.451l-4.164 3.77a2 2 0 00-.628 1.829l1.11 6.313c.286 1.63-1.419 2.883-2.889 2.122l-5.493-2.841a2 2 0 00-1.838 0l-5.493 2.841c-1.47.76-3.175-.492-2.889-2.122l1.11-6.313a2 2 0 00-.628-1.83z","stroke":"#fff"}})])
          )
        }
      }
    